import React, { useEffect, useState } from 'react';
// Material-UI imports removidos em favor do Tailwind Glassmorphism
import jsPDF from 'jspdf';
import axios from "axios";

import logo from "../assets/logo.png";
import churrasqueira1 from "../assets/2-espetos.png";
import churrasqueira2 from "../assets/3-espetos.png";
import churrasqueira3 from "../assets/5-espetos.png";
import churrasqueira4 from "../assets/7-espetos.png";
import churrasqueira5 from "../assets/9-espetos.png";


const GerarOrcamento = () => {
    const [clientes, setClientes] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [clienteSelecionado, setClienteSelecionado] = useState('');
    const [quantidades, setQuantidades] = useState({}); // Quantidades de produtos selecionados
    const [produtosSelecionados, setProdutosSelecionados] = useState({}); // Controle de seleção dos produtos
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [productsPerPage] = useState(14);
    const [erroOpenCliente, setErroOpenCliente] = useState(false);
    const [erroOpenProduto, setErroOpenProduto] = useState(false);
    const [erroOpenQuantidade, setErroOpenQuantidade] = useState(false);
    const [imagensSelecionadas, setImagensSelecionadas] = useState([]);
    const [erroImagemSelecionada, setErroImagemSelecionada] = useState(false);
    const [prazoEntrega, setPrazoEntrega] = useState('45');

    useEffect(() => {
        fetchClients();
        fetchProducts();
    }, []);

    const fetchClients = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes`);
            if (Array.isArray(response.data)) {
                setClientes(response.data);
            } else {
                console.error('Erro: dados de clientes não são um array.');
            }
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product`);
            if (Array.isArray(response.data)) {
                setProdutos(response.data);

                // Ordena as categorias (exemplo: ordem alfabética)
                const categoriasUnicas = [...new Set(response.data.map(p => p.categoria))];
                const categoriasOrdenadas = categoriasUnicas.sort();
                setCategorias(categoriasOrdenadas);
            } else {
                console.error('Erro: dados de produtos não são um array.');
            }
        } catch (error) {
            console.error('Erro ao buscar produtos:', error);
        }
    };

    const handleClienteChange = (event) => {
        setClienteSelecionado(event.target.value);
    };

    const handleQuantidadeChange = (produtoId, event) => {
        const quantidade = event.target.value;
        if (quantidade === "" || quantidade >= 0) { // Impede valores negativos, mas permite apagar (string vazia)
            setQuantidades((prevState) => ({
                ...prevState,
                [produtoId]: quantidade,
            }));
        }
    };

    // const handleCheckboxChange = (produtoId) => {
    //     setProdutosSelecionados((prevState) => ({
    //         ...prevState,
    //         [produtoId]: !prevState[produtoId], // Inverte o estado de seleção do produto
    //     }));
    // };

    const handleImagemCheckboxChange = (imagemId) => {
        imagemId = Number(imagemId); // Garante que seja number

        setImagensSelecionadas((prevSelecionadas) => {
            // Se já está selecionado, desmarca
            if (prevSelecionadas.includes(imagemId)) {
                return prevSelecionadas.filter(id => id !== imagemId);
            }

            // Se menos de 2 estão selecionadas, permite adicionar
            if (prevSelecionadas.length < 2) {
                return [...prevSelecionadas, imagemId];
            }

            // Se já há 2 selecionadas, não faz nada
            return prevSelecionadas;
        });
    };

    const handleFiltroCategoriaChange = (event) => {
        setFiltroCategoria(event.target.value);
        setCurrentPage(1);
    };

    const formatarParaBRL = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    };

    function validaProdutosSelecionados () {
        var validador = false;

        produtos.forEach(produto => {
            if (quantidades[produto.id] != undefined && quantidades[produto.id] != 0) {
                validador = true
            }
        });

        return validador
    }

    function validaQuantidadeSelecionados () {
        var quantidade = 0;

        produtos.forEach(produto => {
            if (quantidades[produto.id] != undefined && quantidades[produto.id] != 0) {
                quantidade += 1
            }
        });

        return quantidade
    }

    const gerarOrcamentoPDF = () => {
        if (!clienteSelecionado) {
            setErroOpenCliente(true); // Abre o popup de erro se nenhum cliente foi selecionado
            return;
        }

        if (!validaProdutosSelecionados()) {
            setErroOpenProduto(true); // Abre o popup de erro se nenhum produto foi selecionado
            return;
        }

        if (validaQuantidadeSelecionados() > 12) {
            setErroOpenQuantidade(true); // Abre o popup de erro se muitos produtos foram selecionados
            return;
        }

        // if (imagensSelecionadas.length == 1) {
        //     setErroImagemSelecionada(true);
        //     return;
        // }

        const doc = new jsPDF();

        // Definir o layout da página (em formato ABNT)
        const margem = 10;  // Margem de 10 pixels
        const larguraPagina = 200;  // Largura total da página (210mm - 2 * 10mm)
        const alturaPagina = 290;  // Altura total da página (297mm - 2 * 10mm)

        doc.setFont('Arial', 'normal'); // Fonte Arial
        doc.setFontSize(10); // Tamanho da fonte para todo o documento

        // Inserir o logo da empresa (diminuído)
        doc.addImage(logo, 'PNG', margem, margem, 30, 30);  // Logo da empresa na posição superior esquerda

        // Informações da empresa (Cabeçalho)
        doc.setFontSize(10);
        doc.setFont("Arial", "bold");
        doc.text('Empresa CS Churrasqueiras', margem + 35, margem + 5);  // Nome da empresa em negrito
        doc.setFont("Arial", "normal");
        doc.text('Razão Social: CS CHURRASQUEIRAS GIRATÓRIAS', margem + 35, margem + 10);  // Razão Social
        doc.text('Inscrição Municipal: ', margem + 35, margem + 15);  // Inscrição Municipal na coluna da direita
        doc.text('CNPJ: 30.402.034/0001-73', margem + 35, margem + 20);  // CNPJ
        doc.text('Endereço: Rua Teresina, nº 175, Bairro Tapajós, Município de Indaial/SC', margem + 35, margem + 25);  // Endereço

        // Coluna direita com informações adicionais
        doc.text('Telefone: (47) 98849-2122', margem + 120, margem + 10);  // Telefone na coluna da direita
        doc.text('Email: cleltoncschurrasqueiras@gmail.com', margem + 120, margem + 15);  // Email na coluna da direita
        doc.text('Site: ', margem + 120, margem + 20);  // Site na coluna da direita

        // Linha horizontal para encapsular o cabeçalho
        doc.setLineWidth(0.5);
        doc.line(margem, 40, larguraPagina, 40);  // Linha de separação entre cabeçalho e conteúdo

        let yPosition = 45;

        // Informações do cliente
        const cliente = clientes.find(cliente => String(cliente.id) === String(clienteSelecionado));
        if (!cliente) {
            console.error("Cliente não encontrado.");
            return;
        }

        doc.setFontSize(10);
        doc.text(`Cliente: ${cliente.nome}`, margem, yPosition); // Nome do cliente
        doc.text(`Endereço: ${cliente.rua}, bairro ${cliente.bairro}, ${cliente.cidade} - ${cliente.estado}`, margem, yPosition + 5); // Endereço do cliente
        doc.text(`Cidade: ${cliente.cidade}`, margem, yPosition + 10); // Cidade do cliente
        doc.text(`Telefone: ${cliente.telefone}`, margem, yPosition + 15); // Telefone do cliente
        doc.text(`Email: ${cliente.email}`, margem, yPosition + 20); // Email do cliente

        // Informações adicionais alinhadas à direita
        doc.text(`CPF/CNPJ: ${cliente.cpf_cnpj}`, margem + 120, yPosition); // CPF/CNPJ do cliente
        doc.text(`CEP: ${cliente.cep}`, margem + 120, yPosition + 5); // CEP do cliente

        // Linha horizontal para separar
        yPosition += 25;
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);  // Linha de separação

        // Seção de informações adicionais
        yPosition += 5;
        doc.text(`Operação: Orçamento`, margem, yPosition); // Tipo de operação
        doc.text(`Prazo de entrega: ${prazoEntrega} dias`, margem, yPosition + 5);
        doc.text(`Validade: 10 dias`, margem, yPosition + 10); // Validade do orçamento

        // Data de emissão (data atual)
        const dataEmissao = new Date();
        const dataFormatada = `${dataEmissao.getDate()}/${dataEmissao.getMonth() + 1}/${dataEmissao.getFullYear()}`;
        doc.text(`Data de Emissão: ${dataFormatada}`, margem, yPosition + 15); // Data de emissão

        // Linha horizontal para separar
        yPosition += 20;
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);  // Linha de separação

        // Título "Produtos/Serviços"
        yPosition += 5;
        doc.setFontSize(12);
        doc.setFont("Arial", "bold");
        doc.text('Produtos/Serviços', larguraPagina / 2, yPosition, null, null, 'center'); // Título centralizado
        doc.setFont("Arial", "normal");

        // Linha horizontal abaixo do título
        yPosition += 4;
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);  // Linha de separação

        // Tabela de itens do orçamento (ajuste da largura das colunas)
        yPosition += 8;
        const colunas = ['Quant.', 'Descrição do produto', 'Valor Un.', 'Valor Final'];
        const larguraColunas = [20, 107, 33, 30];  // Ajuste das larguras das colunas para alinhar corretamente

        doc.setFont("Arial", "bold");

        let xPos = margem;
        colunas.forEach((coluna, index) => {
            doc.text(coluna, xPos, yPosition);
            xPos += larguraColunas[index];
        });

        yPosition += 10; // Aumentar a altura após o cabeçalho

        doc.setFont("Arial", "normal");
        doc.setFontSize(10);

        let total = 0;
        produtos.forEach(produto => {
            const quantidade = quantidades[produto.id];
            if (quantidade > 0) {
                const subtotal = produto.valor * quantidade;
                total += subtotal;

                // Verifica se a próxima linha ultrapassará os 5 pixels do final
                if (yPosition + 8 > alturaPagina - 20) {  // Mudança aqui, 20px de margem no final
                    doc.addPage();  // Adiciona uma nova página
                    yPosition = 15; // Redefine a posição Y na nova página
                }

                // Desenhar uma linha para cada produto
                xPos = margem;  // Reinicia a posição horizontal
                doc.text(`${quantidade}`, xPos, yPosition);
                xPos += larguraColunas[0];

                doc.text(`${produto.nome}`, xPos, yPosition);
                xPos += larguraColunas[1];

                doc.text(formatarParaBRL(produto.valor), larguraPagina - 63, yPosition, { align: 'left' }); // Alinhado à direita
                xPos += larguraColunas[2];

                doc.text(formatarParaBRL(subtotal), larguraPagina - 30, yPosition, { align: 'left' }); // Alinhado à direita
                yPosition += 5;  // Ajustar a posição para a próxima linha
            }
        });

        // Adicionar a linha de totalização
        xPos = margem;
        doc.setFontSize(12);
        doc.setFont("Arial", "bold");  // Definindo o texto "Total" em negrito
        doc.text('Total:', larguraPagina - 50, yPosition + 4, { align: 'right' });
        doc.text(formatarParaBRL(total), larguraPagina - 20, yPosition + 4, { align: 'right' });
        yPosition += 8;
        doc.setFont("Arial", "normal");  // Voltando ao estilo normal para o valor total

        // Linha horizontal para separar
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);  // Linha de separação

        // Seção com imagens ilustrativas
        const espacamentoEntreImagens = 10;
        const imagemLargura = 60;  // Corrigido para 60px
        const imagemAltura = 45;  // Corrigido para 45px
        const posicaoX1 = (larguraPagina - (imagemLargura * 2 + espacamentoEntreImagens)) / 2; // Calcular o X para centralizar as imagens

        const imagensMapeadas = {
            1: churrasqueira1,
            2: churrasqueira2,
            3: churrasqueira3,
            4: churrasqueira4,
            5: churrasqueira5
        };

        imagensSelecionadas.forEach((id, index) => {
            const img = imagensMapeadas[id];
            const x = posicaoX1 + index * (imagemLargura + espacamentoEntreImagens);
            doc.addImage(img, 'PNG', x, yPosition + 5, imagemLargura, imagemAltura);
            doc.setTextColor(169, 169, 169);
            doc.setFontSize(8);
            doc.text('* Imagem meramente ilustrativa', x, yPosition + 55);
        });

        // Adicionar o texto abaixo das imagens com espaçamento
        doc.setTextColor(169, 169, 169);  // Cor cinza claro para as legendas
        doc.setFontSize(8);
        doc.text('* Imagem meramente ilustrativa', posicaoX1, yPosition + 55);
        doc.text('* Imagem meramente ilustrativa', posicaoX1 + imagemLargura + espacamentoEntreImagens, yPosition + 55);

        // Linha inferior
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition + 60, larguraPagina, yPosition + 60);  // Linha inferior

        // Seção de "Observações Comerciais"
        yPosition += 70;
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0); // Cor preta
        doc.text('Observações Comerciais:', margem, yPosition);
        yPosition += 7;

        const observacoes = [
            '- Garantia de 06 (seis) meses para a parte elétrica dos produtos.',
            '- Garantia de 03 (três) anos para defeitos de fabricação conforme contrato.',
            '- Garantia de 10 (dez) anos para as peças de inox contra oxidação natural.'
        ];

        observacoes.forEach((obs, index) => {
            doc.text(obs, margem, yPosition + (index * 5));
        });

        // Rodapé - Ajuste para ficar a 10 pixels do final
        const yRodape = alturaPagina - 1;  // Posição para o rodapé a 10 pixels do final da página
        const dataRodape = new Date().toLocaleDateString('pt-BR');
        doc.setFontSize(8);
        doc.setTextColor(169, 169, 169);  // Cor cinza para o rodapé

        // Alinhamento do rodapé (data à direita e nome da empresa à esquerda)
        doc.text(dataRodape, larguraPagina - 20, yRodape, { align: 'right' });  // Data à direita
        doc.text(`CS Churrasqueiras`, margem, yRodape);  // Nome da empresa à esquerda

        // Extrair o nome do cliente e usar apenas o primeiro e segundo nome
        const nomeCliente = cliente.nome.trim().split(' ').slice(0, 2).join(' ');  // Pega apenas o primeiro e segundo nome
        const nomeArquivo = `Orcamento - ${nomeCliente}.pdf`;  // Cria o nome do arquivo

        // Salvar o PDF com o nome "orcamento-'primeiro e segundo nome do cliente'"
        doc.save(nomeArquivo);
    };

    // Ordena os produtos por categoria e nome antes de exibir
    const produtosOrdenados = produtos
        .filter(produto => !filtroCategoria || produto.categoria === filtroCategoria)
        .sort((a, b) => {
            if (a.categoria === b.categoria) {
                return a.nome.localeCompare(b.nome);
            }
            return a.categoria.localeCompare(b.categoria);
        });

    const totalPages = Math.ceil(produtosOrdenados.length / productsPerPage);
    const currentProducts = produtosOrdenados.slice((currentPage - 1) * productsPerPage, currentPage * productsPerPage);

    const handlePageChange = (direction) => {
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        } else if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    // Função para fechar o popup de erro
    const handleCloseError = () => {
        setErroOpenCliente(false);
        setErroOpenProduto(false);
        setErroOpenQuantidade(false);
        setErroImagemSelecionada(false);
    };

    return (
        <div className="p-4 md:p-8 animate-fade-in max-w-7xl mx-auto">
            <div className="flex flex-col mb-8">
                <h1 className="text-3xl font-serif text-white font-bold tracking-wide">Geração de Orçamento</h1>
                <p className="text-gray-400 mt-2 text-sm">Selecione o cliente, defina o prazo e as quantidades de produtos.</p>
            </div>

            <div className="flex flex-col lg:flex-row gap-8">
                {/* Coluna Esquerda: Filtros e Configurações */}
                <div className="w-full lg:w-1/3 flex flex-col gap-6">
                    <div className="glass-panel p-6">
                        <h2 className="text-xl font-bold text-white mb-4">Configuração Principal</h2>
                        <div className="h-px bg-white/10 w-full mb-6"></div>
                        
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-200 mb-1">Cliente</label>
                                <select 
                                    value={clienteSelecionado} 
                                    onChange={handleClienteChange} 
                                    className="glass-input w-full appearance-none bg-background-darker"
                                >
                                    <option value="" disabled>Selecione um cliente</option>
                                    {clientes.map(cliente => (
                                        <option key={cliente.id} value={cliente.id}>{cliente.nome}</option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-200 mb-1">Prazo de Entrega (dias)</label>
                                <input
                                    type="number"
                                    value={prazoEntrega}
                                    onChange={(e) => setPrazoEntrega(e.target.value)}
                                    className="glass-input w-full"
                                    min="1"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="glass-panel p-6">
                        <h2 className="text-xl font-bold text-white mb-4">Filtros de Produtos</h2>
                        <div className="h-px bg-white/10 w-full mb-6"></div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200 mb-1">Categoria</label>
                            <select
                                value={filtroCategoria}
                                onChange={handleFiltroCategoriaChange}
                                className="glass-input w-full appearance-none bg-background-darker"
                            >
                                <option value="">Todas as Categorias</option>
                                {categorias.map((categoria, index) => (
                                    <option key={index} value={categoria}>{categoria}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="glass-panel p-6">
                        <h2 className="text-xl font-bold text-white mb-4">Selecionar Imagens</h2>
                        <p className="text-xs text-gray-400 mb-4">(Escolha até 2 tipos)</p>
                        <div className="h-px bg-white/10 w-full mb-6"></div>

                        <div className="flex flex-col space-y-3">
                            {[
                                { id: 1, label: '2 Espetos' },
                                { id: 2, label: '3 Espetos' },
                                { id: 3, label: '5 Espetos' },
                                { id: 4, label: '7 Espetos' },
                                { id: 5, label: '9 Espetos' }
                            ].map(img => (
                                <label key={img.id} className="relative flex items-center p-3 cursor-pointer group bg-white/5 rounded-xl hover:bg-white/10 transition-all border border-white/5 hover:border-white/20">
                                    <input 
                                        type="checkbox" 
                                        checked={imagensSelecionadas.includes(img.id)}
                                        onChange={() => handleImagemCheckboxChange(img.id)}
                                        className="peer sr-only"
                                    />
                                    <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded border-2 border-gray-500 peer-checked:border-primary peer-checked:bg-primary transition-all shadow-none peer-checked:shadow-[0_0_10px_rgba(59,130,246,0.6)]">
                                        <svg className="w-3 h-3 text-white opacity-0 peer-checked:opacity-100 transition-opacity" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <span className="ml-3 text-gray-300 font-medium group-hover:text-white peer-checked:text-white transition-colors">{img.label}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Coluna Direita: Lista de Produtos */}
                <div className="w-full lg:w-2/3">
                    <div className="glass-panel p-6 h-full flex flex-col">
                        <h2 className="text-xl font-bold text-white mb-4">Lista de Produtos</h2>
                        <div className="h-px bg-white/10 w-full mb-6"></div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 flex-grow content-start">
                            {currentProducts.map((produto) => (
                                <div key={produto.id} className="bg-white/5 border border-white/10 rounded-xl p-4 flex justify-between items-center hover:bg-white/10 transition-colors">
                                    <div className="pr-4">
                                        <h3 className="font-semibold text-white text-sm mb-1 line-clamp-2">{produto.nome}</h3>
                                        <p className="text-green-400 font-medium text-xs">{formatarParaBRL(produto.valor)}</p>
                                    </div>
                                    <div>
                                        <label className="block text-xs text-gray-400 mb-1 text-center">Qtd.</label>
                                        <input
                                            type="number"
                                            value={quantidades[produto.id] !== undefined ? quantidades[produto.id] : 0}
                                            onChange={(e) => handleQuantidadeChange(produto.id, e)}
                                            className="glass-input w-20 text-center py-1"
                                            min="0"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Paginação */}
                        <div className="flex justify-between items-center mt-8">
                            <button
                                onClick={() => handlePageChange('prev')}
                                disabled={currentPage === 1}
                                className={`px-4 py-2 rounded-lg font-medium transition-colors ${currentPage === 1 ? 'bg-white/5 text-gray-600 cursor-not-allowed' : 'glass-button'}`}
                            >
                                Anterior
                            </button>
                            <span className="text-gray-400 text-sm">
                                Página {currentPage} de {totalPages}
                            </span>
                            <button
                                onClick={() => handlePageChange('next')}
                                disabled={currentPage === totalPages || totalPages === 0}
                                className={`px-4 py-2 rounded-lg font-medium transition-colors ${currentPage === totalPages || totalPages === 0 ? 'bg-white/5 text-gray-600 cursor-not-allowed' : 'glass-button'}`}
                            >
                                Próximo
                            </button>
                        </div>

                        {/* Botão Gerar Orçamento */}
                        <div className="mt-8 flex justify-center">
                            <button
                                onClick={gerarOrcamentoPDF}
                                className="glass-button bg-blue-600/80 hover:bg-blue-600 text-white px-8 py-3 text-lg font-medium flex items-center justify-center w-full md:w-auto"
                            >
                                Gerar Orçamento em PDF
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modais de Erro Tailwind */}
            {(erroOpenCliente || erroOpenProduto || erroOpenQuantidade || erroImagemSelecionada) && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50 p-4">
                    <div className="glass-panel p-6 max-w-sm w-full animate-fade-in">
                        <h2 className="text-xl font-bold text-red-400 mb-4">Atenção</h2>
                        <div className="text-gray-200 mb-6">
                            {erroOpenCliente && <p>Por favor, selecione um cliente para gerar o orçamento.</p>}
                            {erroOpenProduto && <p>Por favor, selecione ao menos um produto para gerar o orçamento.</p>}
                            {erroOpenQuantidade && <p>Por favor, não selecione mais de 12 produtos para gerar o orçamento.</p>}
                            {erroImagemSelecionada && <p>Por favor, selecione um tipo de imagem para gerar o orçamento.</p>}
                        </div>
                        <div className="flex justify-end">
                            <button onClick={handleCloseError} className="glass-button bg-red-500/20 hover:bg-red-500/40 text-red-400">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GerarOrcamento;
